export enum RequestedInformation {
  SerializedBacklog = 1 << 0,
  BacklogPushError = 1 << 1,
}
